"use client"

import React, { createContext, useContext, useState, useEffect, ReactNode } from "react"

interface ConfigurationContextType {
  currencySymbol: string
  timezone: string
  refreshConfiguration: () => Promise<void>
}

const ConfigurationContext = createContext<ConfigurationContextType | undefined>(undefined)

export function ConfigurationProvider({ children }: { children: ReactNode }) {
  const [currencySymbol, setCurrencySymbol] = useState("Rs.")
  const [timezone, setTimezone] = useState("Asia/Colombo")

  const refreshConfiguration = async () => {
    try {
      const response = await fetch("/api/configurations", { credentials: "include" })
      if (response.ok) {
        const data = await response.json()
        setCurrencySymbol(data.currency_symbol || "Rs.")
        setTimezone(data.timezone || "Asia/Colombo")
      }
    } catch (err) {
      console.error("Failed to fetch configuration:", err)
    }
  }

  useEffect(() => {
    refreshConfiguration()
  }, [])

  return (
    <ConfigurationContext.Provider value={{ currencySymbol, timezone, refreshConfiguration }}>
      {children}
    </ConfigurationContext.Provider>
  )
}

export function useConfiguration() {
  const context = useContext(ConfigurationContext)
  if (context === undefined) {
    throw new Error("useConfiguration must be used within a ConfigurationProvider")
  }
  return context
}
